<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("apartment.title_available_lease_back") }}</b>
            </div>
            <div class="col-md-12 col-ld-12 col-sd-12">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_from") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      :value="bookingDate.checkin_datetime"
                      v-model="bookingDate.checkin_datetime"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_to") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      :value="bookingDate.checkout_datetime"
                      v-model="bookingDate.checkout_datetime"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <!-- Search booking available list -->
              <div class="col-sm-2 col-md-2 col-lg-2">
                <button
                  :disabled="isDisable"
                  type="button"
                  class="btn btn-labeled btn-warning pull-left"
                  @click="onSearchAvailableApartment"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.check_availability_button") }}
                </button>
              </div>
              <!-- Customer Company Booking -->
              <div class="col-sm-2 col-md-2 col-lg-2">
                <button
                  :disabled="isDisable"
                  type="button"
                  class="btn btn-labeled btn-warning pull-left"
                  @click="onBookingForCompany"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  Khách đoàn / Cty
                </button>
              </div>
              <!-- Apartment client booking list -->
              <div v-if="false" class="col-sm-2 col-md-2 col-lg-2">
                <button
                  :disabled="isDisable"
                  type="button"
                  class="btn btn-labeled btn-primary pull-left"
                  @click="onShowModalLeaseBackApartmentClientBooking"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-list"></i>
                  </span>
                  Khách hàng lưu trú
                </button>
              </div>
            </div>
          </div>
          <div class="box-body"><!-- No thing --></div>
          <!--Remark-->
          <div
            style="border:0px solid blue;margin-bottom:20px;margin-left:10px;padding:10px 0px 10px 0px;"
          >
            <div class="row">
              <div
                class="col-sm-4 col-md-2"
                style="border:0px solid red;flex-wrap: nowrap;"
              >
                <div
                  style="float:left;width:38px;background-color:#3c8dbc;height:30px;
              border:0px solid green;border-radius:4px;"
                >
                  <span
                    style="text-align:center;margin-top:5px;display:block;color:white;"
                    >{{ remark.empty }}</span
                  >
                </div>
                <button
                  @click="makeColorButton('isEmpty')"
                  :class="{ colorbutton: controlStatusBooking.isEmpty }"
                  class="btn btn-sm btn-bitbucket"
                  style="margin-left:5px;height:30px;"
                >
                  {{ $t("apartmentbookings.status_booking.available") }}
                </button>
              </div>

              <div
                class="col-sm-4 col-md-2"
                style="border:0px solid red;flex-wrap: nowrap;"
              >
                <div
                  style="float:left;width:38px;background-color:yellowgreen;height:30px;
              border:0px solid green;text-align:left;border-radius:4px;margin-left:-2px;"
                >
                  <span
                    style="text-align:center;margin-top:5px;display:block;color:white;"
                    >{{ remark.confirmed }}</span
                  >
                </div>
                <button
                  @click="makeColorButton('isConfirm')"
                  :class="{ colorbutton: controlStatusBooking.isConfirm }"
                  class="btn btn-sm btn-bitbucket"
                  style="margin-left:5px;height:30px;"
                >
                  {{ $t("apartmentbookings.status.confirmed") }}
                </button>
              </div>

              <div
                class="col-sm-4 col-md-2"
                style="border:0px solid red;flex-wrap: nowrap;"
              >
                <div
                  style="float:left;width:38px;background-color:rgb(0, 166, 90);height:30px;
              border:0px solid green;text-align:left;border-radius:4px;margin-left:-5px;"
                >
                  <span
                    style="text-align:center;margin-top:5px;display:block;color:white;"
                    >{{ remark.onboard }}</span
                  >
                </div>
                <button
                  @click="makeColorButton('isOnboard')"
                  :class="{ colorbutton: controlStatusBooking.isOnboard }"
                  class="btn btn-sm btn-bitbucket"
                  style="margin-left:5px;height:30px;"
                >
                  {{ $t("apartmentbookings.status.onboard") }}
                </button>
              </div>

              <div
                class="col-sm-4 col-md-2"
                style="border:0px solid red;flex-wrap: nowrap;"
              >
                <div
                  style="float:left;width:38px;background-color:rgb(243, 156, 18);height:30px;
              border:0px solid green;text-align:left;border-radius:4px;margin-left:-4px;"
                >
                  <span
                    style="text-align:center;margin-top:5px;display:block;color:white;"
                    >{{ remark.checkincommingsoon }}</span
                  >
                </div>
                <button
                  @click="makeColorButton('isCheckinSoon')"
                  :class="{ colorbutton: controlStatusBooking.isCheckinSoon }"
                  class="btn btn-sm btn-bitbucket"
                  style="margin-left:5px;height:30px;"
                >
                  {{ $t("apartmentbookings.status.checkincommingsoon") }}
                </button>
              </div>

              <div
                class="col-sm-4 col-md-2"
                style="border:0px solid red;flex-wrap: nowrap;"
              >
                <div
                  style="float:left;width:38px;background-color:rgb(245, 105, 84);height:30px;
              border:0px solid green;text-align:left;border-radius:4px;margin-left:-6px;"
                >
                  <span
                    style="text-align:center;margin-top:5px;display:block;color:white;"
                    >{{ remark.checkoutcommingsoon }}</span
                  >
                </div>
                <button
                  @click="makeColorButton('isCheckoutSoon')"
                  :class="{ colorbutton: controlStatusBooking.isCheckoutSoon }"
                  class="btn btn-sm btn-bitbucket"
                  style="margin-left:5px;height:30px;"
                >
                  {{ $t("apartmentbookings.status.checkoutcommingsoon") }}
                </button>
              </div>

              <div
                class="col-sm-4 col-md-2"
                style="border:0px solid red;flex-wrap: nowrap;"
              >
                <div
                  style="float:left;width:38px;background-color:rgb(96, 92, 168);height:30px;
              border:0px solid green;text-align:left;border-radius:4px;margin-left:-10px;"
                >
                  <span
                    style="text-align:center;margin-top:5px;display:block;color:white;"
                    >{{ remark.deposit }}</span
                  >
                </div>
                <button
                  @click="makeColorButton('isDeposit')"
                  :class="{ colorbutton: controlStatusBooking.isDeposit }"
                  class="btn btn-sm btn-bitbucket"
                  style="margin-left:5px;height:30px;"
                >
                  {{ $t("apartmentbookings.status.deposit") }}
                </button>
              </div>
            </div>
          </div>
          <!--Remark-->

          <!--Room-->
          <div
            style="border:0px solid blue;margin-top:-20px;margin-left:10px;padding:10px 0px 10px 0px;"
          >
            <div class="row">
              <div
                class="col-sm-4 col-md-2"
                style="border:0px solid red;flex-wrap: nowrap;"
              >
                <div
                  style="float:left;width:38px;height:30px;
              border:2px solid fuchsia;border-radius:4px;"
                >
                  <span
                    style="text-align:center;margin-top:3px;display:block;color:black;font-weight:bold;"
                    >{{ bedrooms.one_bedroom }}</span
                  >
                </div>
                <div style="margin:7px 0px 0px 5px;float:left;">
                  &nbsp;&nbsp;&nbsp;1
                  {{ $t("apartment.reservations.bedrooms") }}
                </div>
              </div>

              <div
                class="col-sm-4 col-md-2"
                style="border:0px solid red;flex-wrap: nowrap;"
              >
                <div
                  style="float:left;width:38px;height:30px;
              border:2px solid chocolate;text-align:left;border-radius:4px;margin-left:-2px;"
                >
                  <span
                    style="text-align:center;margin-top:3px;display:block;color:black;font-weight:bold;"
                    >{{ bedrooms.two_bedroom }}</span
                  >
                </div>
                <div style="margin:7px 0px 0px 5px;float:left;">
                  &nbsp;&nbsp;&nbsp;2
                  {{ $t("apartment.reservations.bedrooms") }}
                </div>
              </div>

              <div
                class="col-sm-4 col-md-2"
                style="border:0px solid red;flex-wrap: nowrap;"
              >
                <div
                  style="float:left;width:38px;height:30px;
              border:2px solid navy;text-align:left;border-radius:4px;margin-left:-5px;"
                >
                  <span
                    style="text-align:center;margin-top:3px;display:block;color:black;font-weight:bold;"
                    >{{ bedrooms.three_bedroom }}</span
                  >
                </div>
                <div style="margin:7px 0px 0px 5px;float:left;">
                  &nbsp;&nbsp;&nbsp;3
                  {{ $t("apartment.reservations.bedrooms") }}
                </div>
              </div>
            </div>
          </div>
          <!--Room-->
        </div>
        <div
          class="box-footer clearfix"
          style="display:contents;"
          v-if="has_perm('view_apartment') || GET_ACCOUNT_DATA.id == 1"
        >
          <paginator
            v-show="false"
            :item="paginatorItem"
            @onpaginate="onPagination"
          />
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-modal
          v-show="isModalMoveToServiceApartment"
          @onConfirm="onConfirmMoveToResidentApartment"
          @close="closeModalMoveTo"
          v-for="obj in objModalMoveToResidentApartment"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-modal-booking-detail
          ref="modalBookingDetail"
          @callbackGetLeaseBackAvailableApartment="onSearchAvailableApartment"
        ></lte-modal-booking-detail>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
        <!--component-->
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li
              v-for="(tab_floor_li, index_li, id_li) in tabs_floor"
              v-bind:key="index_li"
              :class="{ active: id_li == 0 }"
            >
              <a
                :href="'#tab_' + index_li"
                data-toggle="tab"
                aria-expanded="true"
              >
                {{ $t("apartment.floor") }} {{ index_li }}
                <div
                  style="margin-right: -13px;
    margin-left: 10px;width:20px;height:20px;background:orangered;border-radius:50%;color:white;margin-top:-10px;float:right;text-align:center;"
                >
                  {{ tab_floor_li.length }}
                </div>
              </a>
            </li>
            <li>
              <a href="#tab_all" data-toggle="tab" aria-expanded="true">
                {{ $t("apartmentbookings.info_tab.all") }}
                <div
                  style="margin-right: -13px;
    margin-left: 10px;width:20px;height:20px;background:orangered;border-radius:50%;color:white;margin-top:-10px;float:right;text-align:center;"
                >
                  {{ gridApartmentDataList.length }}
                </div>
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <div
              class="tab-pane"
              v-for="(tab_floor_ct, index_ct, id_ct) in tabs_floor"
              v-bind:key="index_ct"
              :id="`tab_${index_ct}`"
              :class="{ active: id_ct == 0 }"
            >
              <div class="row">
                <div
                  style="text-align:center; color: red;"
                  v-show="tab_floor_ct.length <= 0"
                >
                  {{ $t("apartmentbookings.noresultsfound") }}
                </div>
                <div v-for="item in tab_floor_ct" :key="item.id">
                  <div v-contextmenu:contextmenu>
                    <lte-booking
                      :item="item"
                      :item1="cleaning_control"
                      :item2="cleaning_control_update"
                      @apartmentbooking="apartmentBooking"
                      @quickActions="openBooking"
                      @getdatalist="getDataList"
                      @notshowcontextmenu="notShowContextMenu"
                      @openBooking="openBooking"
                      @onCheckOut="onCheckOut"
                    >
                      <font-awesome-icon icon="times" class="float-right" />
                    </lte-booking>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="tab_all">
              <div class="row">
                <div
                  style="text-align:center; color: red;"
                  v-show="gridApartmentDataList.length <= 0"
                >
                  {{ $t("apartmentbookings.noresultsfound") }}
                </div>
                <div v-for="item in gridApartmentDataList" :key="item.id">
                  <div v-contextmenu:contextmenu>
                    <lte-booking
                      :item="item"
                      :item1="cleaning_control"
                      :item2="cleaning_control_update"
                      @apartmentbooking="apartmentBooking"
                      @quickActions="openBooking"
                      @getdatalist="getDataList"
                      @notshowcontextmenu="notShowContextMenu"
                      @openBooking="openBooking"
                      @onCheckOut="onCheckOut"
                    ></lte-booking>
                  </div>
                </div>
              </div>
            </div>
            <v-contextmenu ref="contextmenu">
              <v-contextmenu-item
                @click="openModalApartment('modal-update-apartment')"
                :disabled="show_context_menu"
              >
                <i class="fa fa-plus" style="color:#ff8000"></i>
                {{ $t("context_menu.update_apartment") }}
              </v-contextmenu-item>
              <v-contextmenu-item
                @click="openModalApartment('modal-all-bookings-apartment')"
                :disabled="show_context_menu"
              >
                <i class="fa fa-plus" style="color:#ff8000"></i>
                {{ $t("context_menu.all_bookings") }}
              </v-contextmenu-item>
              <v-contextmenu-item
                v-show="data_context_menu.status == 1"
                @click="apartmentBooking(data_context_menu.id)"
                :disabled="show_context_menu"
              >
                <i class="fa fa-book" style="color:#ff8000"></i>
                {{ $t("context_menu.booking") }}
              </v-contextmenu-item>
              <v-contextmenu-item
                v-show="data_context_menu.status == 2"
                @click="openBooking(data_context_menu.booking_id)"
                :disabled="show_context_menu"
              >
                <i class="fa fa-calendar-check-o" style="color:#ff8000"></i>
                {{ $t("context_menu.checkin") }}
              </v-contextmenu-item>
              <v-contextmenu-item
                v-show="data_context_menu.status == 8"
                :disabled="show_context_menu"
              >
                <i class="fa fa-calendar-minus-o" style="color:#ff8000"></i>
                {{ $t("context_menu.checkout") }}
              </v-contextmenu-item>
              <v-contextmenu-item
                :disabled="show_context_menu"
                :item="obj_update"
                @click="
                  openCleaningService(
                    'modal-cleaing-service',
                    obj_update.id,
                    obj_update.cleaning_status,
                    obj_update.cleaning_status_id
                  )
                "
              >
                <i class="fa fa-paint-brush" style="color:#ff8000"></i> Dịch Vụ
                Phòng
              </v-contextmenu-item>
            </v-contextmenu>
          </div>
        </div>
        <!--component-->
      </row>
    </div>
    <!--Modal Update Apartment-->
    <div class="modal fade" data-backdrop="static" id="modal-update-apartment">
      <div class="modal-dialog" style="width:75% !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">{{ $t("apartment.editaddnew[1]") }}</h2>
          </div>
          <div class="modal-body">
            <b-form>
              <div class="row" v-if="obj_update.id != 0">
                <leaseback-apartment-inputview
                  ref="LeaseBackApartmentInputView"
                  @closeModal="closeModalApartment('modal-update-apartment')"
                  :item="obj_update"
                ></leaseback-apartment-inputview>
              </div>
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModalApartment('modal-update-apartment')"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-labeled btn-success pull-right"
              @click="updateApartment"
              style="margin-right: 5px;"
            >
              <span class="btn-label">
                <i class="glyphicon glyphicon-ok"></i>
              </span>
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!--Modal Update Apartment-->

    <!--Modal Cleaning Service -->
    <div class="modal fade" data-backdrop="static" id="modal-cleaing-service">
      <div class="modal-dialog" style="width:38% !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">Dịch Vụ Phòng</h2>
          </div>
          <div class="modal-body">
            <b-form>
              <div class="row" v-if="obj_update.id != 0">
                <leaseback-apartment-cleaning-service
                  ref="LeaseBackApartmentCleaningService"
                  @closeModal="closeModalApartment('modal-cleaing-service')"
                  :item="obj_update"
                  @returnCleaningStatus="getCleaningStatus"
                  @returnCleaningId="getCleaningId"
                ></leaseback-apartment-cleaning-service>
              </div>
            </b-form>
          </div>
          <div class="modal-footer">
            <!-- <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModalApartment('modal-cleaing-service')"
            >{{$t('common.cancel')}}</button>
            <button
              type="button"
              class="btn btn-labeled btn-success pull-right"
              @click="updateApartment"
              style="margin-right: 5px;"
            >
              <span class="btn-label">
                <i class="glyphicon glyphicon-ok"></i>
              </span>
              {{$t('common.save')}}
            </button>-->
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!--Modal Cleaning Service-->

    <!--Modal View all bookings of Apartment-->
    <div
      class="modal fade"
      data-backdrop="static"
      id="modal-all-bookings-apartment"
    >
      <div class="modal-dialog" style="width:75% !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">{{ $t("context_menu.all_bookings") }}</h2>
          </div>
          <div class="modal-body">
            <b-form>
              <div class="row" v-if="obj_update.id != 0">
                <leaseback-tenant-booking
                  @closeModal="
                    closeModalApartment('modal-all-bookings-apartment')
                  "
                  :item="obj_update"
                ></leaseback-tenant-booking>
              </div>
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModalApartment('modal-all-bookings-apartment')"
            >
              {{ $t("common.cancel") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!--Modal View all bookings of Apartment-->
    <!-- Modal Booking Payment -->
    <div class="modal fade" :ref="`modal-booking-payment`">
      <div class="modal-dialog modal-lg">
        <LeaseBackBookingPayment
          ref="bookingPaymentComponent"
          :item="bookingPaymentData"
          @onAdd="onAddPayment"
          @onSave="onSavePayment"
          @onCheckout="onCheckoutApartmentBooking"
          @onClose="onClosePayment"
        />
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- Modal leaseback apartment client -->
    <leaseback-apartment-client-booking ref="leasebackApartmentClientBooking" />
    <!-- /.modal -->
    <!-- END Modal Booking Payment -->
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
// import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import booking from "@/components/LTEBooking";
import datePicker from "vue-bootstrap-datetimepicker";
import LTEModalBookingDetail from "@/components/LTEModalBookingDetail";
import LeaseBackApartmentInputView from "./LeaseBackApartmentInputView";
import LeaseBackTenantBooking from "./LeaseBackTenantBooking";
import LeaseBackBookingPayment from "./LeaseBackBookingPayment";
import LeaseBackApartmentClientBookingList from "./LeaseBackApartmentClientBookingList";
import LeaseBackApartmentCleaningService from "./LeaseBackApartmentCleaningService";
import BookingStatusEnum from "@/enum/bookingStatusEnum";
import constants from "@/lib/constantsData";

export default {
  name: "LeaseBackAvailableApartmentList",
  data() {
    return {
      cleaning_control: [],
      cleaning_control_update: [],
      buttonName: "danger",
      labelName: "Name",
      gridApartmentDataList: [],
      apartmentBookingList: {},
      useFilter: false,
      boxStyle: false,
      useCheckBox: true,
      remark: {
        empty: 0,
        confirmed: 0,
        onboard: 0,
        checkincommingsoon: 0,
        checkoutcommingsoon: 0,
        deposit: 0
      },
      bedrooms: {
        one_bedroom: 0,
        two_bedroom: 0,
        three_bedroom: 0
      },
      list_apartment_id: [],
      bookingDate: {
        checkin_datetime: null,
        checkout_datetime: null,
        apartment_booking_status: []
      },
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "common.code", isHidden: true },
        { text: "apartment.apartment_code", isHidden: true },
        { text: "apartment.size", isHidden: true },
        { text: "apartment.status", isHidden: true },
        { text: "apartment.owner_resident", isHidden: true }
      ],
      columnsApartment: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      columnApartmentStatus: {
        data_list: constants.apartmentStatusText,
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        apartment: true
      },
      statusSelected: [],
      actions: ["common.booking"],
      //hdBackground         : "background-color: #4b646f;color:white;border-bottom:2px solid #f4f4f4;", //00a65a
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      isModalMoveToServiceApartment: false,
      objModal: [
        {
          title    : "common.delete_modal.title",
          body     : "common.delete_modal.content",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      objModalMoveToResidentApartment: [
        {
          title: "Chuyển Đổi Căn Hộ Tới Căn Hộ Dịch Vụ",
          body:
            "Bạn có chắc chắn muốn chuyển đổi căn hộ tới căn hộ dịch vụ không?",
          buttonNo: "Hủy",
          buttonYes: "Đồng Ý",
          styleType: "default"
        }
      ],
      paginatorItem: {
        commit_function: "GET_AVAILABLE_APARTMENT_LIST"
      },
      search: {
        code: "",
        apartment_code: "",
        fromsize: "",
        tosize: "",
        status: "",
        owner_resident: ""
      },
      isLoading: false,
      module_id: 4,
      permissions: [],
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      booking_id: null,
      controlStatusBooking: {
        isEmpty: false,
        isConfirm: false,
        isOnboard: false,
        isCheckinSoon: false,
        isCheckoutSoon: false,
        isDeposit: false
      },
      tabs_floor: {},
      show_context_menu: false,
      data_context_menu: {},
      is_both: false,
      obj_update: {
        id: 0,
        checkin: null,
        checkout: null,
        cleaning_status: 0,
        cleaning_status_id: 0
      },
      bookingPaymentData: {
        booking_id: 0,
        apartment_id: 0
      }
    };
  },
  watch: {
    GET_LANG: function() {
      const data = {
        params: {
          page: 1,
          apt_type: 2,
          checkin_datetime: utils.formatSqlDate(this.bookingDate.checkin_datetime, this.options.format, "DD/MM/YYYY"),
          checkout_datetime: utils.formatSqlDate(this.bookingDate.checkout_datetime, this.options.format, "DD/MM/YYYY"),
          absc: this.bookingDate.apartment_booking_status
        }
      };

      this.GET_AVAILABLE_APARTMENT_LIST(data);
    },
    GET_AVAILABLE_APARTMENT_DATA: function() {
      this.gridApartmentDataList = [];
      this.remark.empty = 0;
      this.remark.confirmed = 0;
      this.remark.onboard = 0;
      this.remark.checkincommingsoon = 0;
      this.remark.checkoutcommingsoon = 0;
      this.remark.deposit = 0;
      this.bedrooms.one_bedroom = 0;
      this.bedrooms.two_bedroom = 0;
      this.bedrooms.three_bedroom = 0;
      let data_list = [];
      this.GET_AVAILABLE_APARTMENT_DATA.forEach((apartment, i) => {
        if (
          !utils.isNull(apartment.booking.booking_status) &&
          apartment.booking.booking_status == BookingStatusEnum.CONFIRMED
        ) {
          this.remark.confirmed += 1;
        } else if (
          !utils.isNull(apartment.booking.booking_status) &&
          apartment.booking.booking_status == BookingStatusEnum.ONBOARD
        ) {
          this.remark.onboard += 1;
        } else if (
          !utils.isNull(apartment.booking.booking_status) &&
          apartment.booking.booking_status == BookingStatusEnum.CHECKINCOMMINGSOON
        ) {
          this.remark.checkincommingsoon += 1;
        } else if (
          !utils.isNull(apartment.booking.booking_status) &&
          apartment.booking.booking_status == BookingStatusEnum.CHECKOUTCOMMINGSOON
        ) {
          this.remark.checkoutcommingsoon += 1;
        } else if (
          !utils.isNull(apartment.booking.booking_status) &&
          apartment.booking.booking_status == BookingStatusEnum.DEPOSIT
        ) {
          this.remark.deposit += 1;
        } else {
          this.remark.empty += 1;
        }
        /**
         * Bedroom
         */
        let border_bedroom = "transparent";
        let bedroom_count = apartment.bedroom_count;
        let border_bedroom_triangle = "transparent";
        if (
          !utils.isNull(apartment.bedroom_count) &&
          apartment.bedroom_count == 1
        ) {
          this.bedrooms.one_bedroom += 1;
          border_bedroom = "2px solid fuchsia ";
          border_bedroom_triangle = "gradeTriangleFuchsia";
        } else if (
          !utils.isNull(apartment.bedroom_count) &&
          apartment.bedroom_count == 2
        ) {
          this.bedrooms.two_bedroom += 1;
          border_bedroom = "2px solid chocolate";
          border_bedroom_triangle = "gradeTriangleChocolate";
        } else if (
          !utils.isNull(apartment.bedroom_count) &&
          apartment.bedroom_count == 3
        ) {
          this.bedrooms.three_bedroom += 1;
          border_bedroom = "2px solid navy";
          border_bedroom_triangle = "gradeTriangleNavy";
        } else {
          border_bedroom = "2px solid #05694d";
          border_bedroom_triangle = "gradeTriangleTransparent";
        }
        /**
         * Bedroom
         */
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = apartment.code;
        let id = apartment.id;
        let apartment_code = apartment.apartment_code;
        let size = apartment.size;
        let checkin_date = this.bookingDate.checkin_datetime;
        let checkout_date = this.bookingDate.checkout_datetime;
        let booking_code = "No Booking";
        let booking_id = null;
        let status =
          apartment.status === 1
            ? this.$t("apartment_status.not_handover")
            : apartment.status === 2
            ? this.$t("apartment_status.handover")
            : apartment.status === 3
            ? this.$t("apartment_status.occupied")
            : apartment.status === 4
            ? this.$t("apartment_status.not_rented")
            : this.$t("apartment_status.rented");
        let full_name_owner = "";
        let booking_status = BookingStatusEnum.UNDEFINED;
        let customer_name = "No Name";
        let bg_color = "#3c8dbc";
        let floor = parseInt(apartment.floor);
        // this.remark.empty = apartment.total_available;
        if (Object.keys(apartment.booking).length > 0) {
          if (
            apartment.booking.booking_status == BookingStatusEnum.CONFIRMED ||
            apartment.booking.booking_status == BookingStatusEnum.ONBOARD ||
            apartment.booking.booking_status == BookingStatusEnum.DEPOSIT
          ) {
            booking_id = apartment.booking.id;
            booking_code = apartment.booking.booking_code;
            customer_name = apartment.booking.booking_person_name
              ? apartment.booking.booking_person_name
              : customer_name;
          }
          checkin_date = utils.formatSqlDate(apartment.booking.checkin_datetime, null, "DD/MM/YYYY");
          checkout_date = utils.formatSqlDate(apartment.booking.checkout_datetime, null, "DD/MM/YYYY");
          booking_status = apartment.booking.booking_status;
          // this.remark.confirmed = apartment.total_booking;
          if (apartment.booking.booking_status == BookingStatusEnum.WAITING) {
            bg_color = "#3c8dbc";
          } else if (apartment.booking.booking_status == BookingStatusEnum.CONFIRMED) {
            //bg_color = "#f39c12"
            //bg_color = "#e67300";
            bg_color = "yellowgreen";
          } else if (apartment.booking.booking_status == BookingStatusEnum.DEPOSIT) {
            //bg_color = "#f39c12"
            //bg_color = "#e67300";
            bg_color = "rgb(96, 92, 168)";
          } else if (apartment.booking.booking_status == BookingStatusEnum.ONBOARD) {
            bg_color = "rgb(0, 166, 90)";
          }
        }
        /*if (Object.keys(apartment.customer).length > 0) {
          if (
            apartment.booking.booking_status == BookingStatusEnum.CONFIRMED ||
            apartment.booking.booking_status == BookingStatusEnum.ONBOARD
          ) {
            customer_name =
              apartment.customer.last_name +
              " " +
              apartment.customer.first_name;
          }
        }
        */
        if (apartment.status != 1) {
          let object_resident = apartment.resident.filter(
            item => item.isOwner === true
          );
          if (object_resident.length > 0) {
            full_name_owner =
              object_resident[0].resident.last_name +
              " " +
              object_resident[0].resident.first_name;
          }
        }
        /**
         * Cleaning Service
         */
        let cleaning_service_status = apartment.cleaning_service_status;
        let cleaning_service_status_id = apartment.cleaning_service_status_id;
        this.cleaning_control[apartment.id] =
          cleaning_service_status != 0 ? cleaning_service_status : 0;
        this.cleaning_control_update[apartment.id] =
          cleaning_service_status_id != 0 ? cleaning_service_status_id : 0;
        let data = {
          /*Comment*/
          id: id,
          "common.nonumber": nonumber,
          "common.code": code,
          apartment_code: apartment_code,
          size: size,
          status: status,
          owner_resident: utils.capitalizeFirstInString(full_name_owner),
          checkin_datetime: checkin_date,
          checkout_datetime: checkout_date,
          booking_code: booking_code,
          customer_name: customer_name,
          bg_color: bg_color,
          border_bedroom: border_bedroom,
          border_bedroom_triangle: border_bedroom_triangle,
          booking_status: booking_status,
          booking_id: booking_id,
          floor: floor,
          bedroom_count: bedroom_count,
          cleaning_service_status: cleaning_service_status,
          cleaning_service_status_id: cleaning_service_status_id
        };
        //this.gridApartmentDataList.push(data);
        data_list.push(data);
      });
      let field = "apartment_code";
      this.gridApartmentDataList = data_list.sort((first, second) =>
        (first[field] || "")
          .toString()
          .localeCompare((second[field] || "").toString())
      );
      this.buildAllApartmentByFloor();
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        let newGridColumns = [];
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        for (
          let j = 0, sizeOrigin = this.gridColumns.length;
          j < sizeOrigin;
          j++
        ) {
          for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
            if (this.gridColumns[j].text == viewedColumnsKey[i]) {
              let viewdColumnObject = {};
              viewdColumnObject.text = viewedColumnsKey[i];
              viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
              newGridColumns.push(viewdColumnObject);
              break;
            }
          }
        }
        this.gridColumns = newGridColumns;
        this.columnsApartment.data_list = this.gridColumns;
      }
    },
    GET_CURRENT_ROLE: function() {}
  },
  computed: {
    isDisable() {
      if (
        this.bookingDate.checkin_datetime != null &&
        this.bookingDate.checkout_datetime != null
      ) {
        return false;
      }
      this.resetApartmentDataList();
      return true;
    },
    ...mapGetters([
      "PAGINATION",
      "GET_SNACK_BAR",
      "GET_APARTMENT_DATA",
      "GET_ACCOUNT_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_LANG",
      "GET_APARTMENTPERMISSIONS_DATA",
      "GET_AVAILABLE_APARTMENT_DATA",
      "GET_APARTMENT_CUSTOMER_INFORMATION_BOOKING_DETAIL_DATA"
    ])
  },
  methods: {
    updateSelectedApartmentStatus: function() {
      if (!utils.isNull(this.statusSelected)) {
        for (let j = 0, sizeApartmentStatus = this.columnApartmentStatus.data_list.length; j < sizeApartmentStatus; j++) {
          for (let k = 0, sizeStatusSelected = this.statusSelected.length; k < sizeStatusSelected; k++) {
            if (this.statusSelected[k] == this.columnApartmentStatus.data_list[j].id) {
              this.columnApartmentStatus.data_list[j]["selected"] = "selected";
            }
          }
        }
      }
    },
    onBookingForCompany: function() {
      this.$router.push({
        name: "LeaseBackApartmentBookingForGroup",
        params: {
          id: 0
        },
        query: {
          checkin_datetime: this.bookingDate.checkin_datetime,
          checkout_datetime: this.bookingDate.checkout_datetime
        }
      });
    },
    onShowModalLeaseBackApartmentClientBooking: function() {
      this.$refs.leasebackApartmentClientBooking.onShowModal(
        this.bookingDate.checkin_datetime,
        this.bookingDate.checkout_datetime
      );
    },
    onClosePayment: function() {
      this.onToggleBookingPaymentModal("hide");
    },
    onSavePayment: function(id, saveBookingPayment, checkout_evt) {
      this.SAVE_BOOKING_PAYMENT({ id: id, data: saveBookingPayment }).then(
        function(res) {
          if (checkout_evt) {
            this.$refs.bookingPaymentComponent.checkOut();
          }
          this.onToggleBookingPaymentModal("hide");
        }.bind(this)
      );
    },
    onAddPayment: function(saveBookingPayment, checkout_evt) {
      this.ADD_BOOKING_PAYMENT(saveBookingPayment).then(
        function(res) {
          if (checkout_evt) {
            this.$refs.bookingPaymentComponent.checkOut();
          }
          this.onToggleBookingPaymentModal("hide");
        }.bind(this)
      );
    },
    onCheckoutApartmentBooking: function(action = "hide") {
      $(this.$refs[`modal-booking-payment`]).modal(action);
      this.getAvailableApartment();
    },
    onToggleBookingPaymentModal: function(action = "show") {
      $(this.$refs[`modal-booking-payment`]).modal(action);
    },
    onCheckOut: function(item) {
      const data = {
        id: 0,
        booking_id: item.booking_id,
        apartment_id: item.id
      };
      this.bookingPaymentData = data;
      this.onToggleBookingPaymentModal();
    },
    buildAllApartmentByFloor: function() {
      this.tabs_floor = {};
      this.gridApartmentDataList.forEach(data => {
        if (this.tabs_floor.hasOwnProperty(data.floor)) {
          for (const floor in this.tabs_floor) {
            if (floor == data.floor) {
              let tmp = [];
              tmp = this.tabs_floor[floor];
              tmp.push(data);
              this.tabs_floor[floor] = tmp;
            }
          }
        } else {
          this.tabs_floor[data.floor] = [data];
        }
      });
    },
    openBooking: function(booking_id) {
      this.$router.push({
        name: "LeaseBackApartmentBooking",
        params: {
          id: booking_id
        },
        query: {
          checkin_datetime: this.bookingDate.checkin_datetime,
          checkout_datetime: this.bookingDate.checkout_datetime
        }
      });
    },
    resetApartmentDataList: function() {
      this.gridApartmentDataList = [];
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSelectApartmentStatus: function(data) {
      if (this.statusSelected.indexOf(parseInt(data.id)) == -1) {
        this.statusSelected.push(parseInt(data.id));
      }
    },
    onUnselectApartmentStatus: function(data) {
      if (this.statusSelected.indexOf(parseInt(data.id)) != -1) {
        this.statusSelected.splice(
          this.statusSelected.indexOf(parseInt(data.id)),
          1
        );
      }
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "apartmentlist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    onSearchApartment: function() {
      return;
      // this.$store.state.apartmentSearchListStorage[
      //   "apartmentCode"
      // ] = this.search.apartment_code;
      // this.$store.state.apartmentSearchListStorage[
      //   "fromSize"
      // ] = this.search.fromsize;
      // this.$store.state.apartmentSearchListStorage[
      //   "toSize"
      // ] = this.search.tosize;
      // this.$store.state.apartmentSearchListStorage[
      //   "ownerCesident"
      // ] = this.search.owner_resident;
      // this.$store.state.apartmentSearchListStorage[
      //   "statusSelected"
      // ] = this.statusSelected;
      // const data = {
      //   params: {
      //     page: 1,
      //     apt_type: 2,
      //     apartment_code: this.search.apartment_code,
      //     from_size: this.search.fromsize,
      //     to_size: this.search.tosize,
      //     status: this.statusSelected,
      //     owner_resident: this.search.owner_resident
      //   }
      // };
      // this.isLoading = true;

      // this.GET_AVAILABLE_APARTMENT_LIST(data).then(
      //   function() {
      //     this.isLoading = false;
      //   }.bind(this)
      // );
    },
    addNew: function() {
      this.$router.push({
        name: "ApartmentAdd",
        params: {
          id: 0
        }
      });
    },
    // importExcel: function() {
    //   this.$router.push({
    //     name: "ApartmentImportExcel",
    //     params: {
    //       id: 0
    //     }
    //   });
    // },
    apartmentBooking: function(apartment_id) {
      this.$router.push({
        name: "LeaseBackApartmentBooking",
        params: {
          /*id: apartment_id,
          checkin_datetime: this.bookingDate.checkin_datetime,
          checkout_datetime: this.bookingDate.checkout_datetime*/
          id: 0
        },
        query: {
          apartment_id: apartment_id,
          checkin_datetime: this.bookingDate.checkin_datetime,
          checkout_datetime: this.bookingDate.checkout_datetime
        }
      });
    },
    onCheckIn: function(booking_id) {
      this.$refs.modalBookingDetail.submit(booking_id);
    },
    onConfirm: function() {
      this.isModalVisible = false;
      // this.search.apartment_code = this.$store.state.apartmentSearchListStorage.apartmentCode;
      // this.search.fromsize = this.$store.state.apartmentSearchListStorage.fromSize;
      // this.search.tosize = this.$store.state.apartmentSearchListStorage.toSize;
      // this.search.owner_resident = this.$store.state.apartmentSearchListStorage.ownerResident;
      // this.statusSelected = this.$store.state.apartmentSearchListStorage.statusSelected;
      this.DELETE_PROPERTY(this.originalRecordData).then(
        function() {
          let currentPage = this.PAGINATION.page;
          let totalPage = this.PAGINATOR.length;
          let page =
            currentPage >= totalPage && this.gridCustomerDataList.length == 1
              ? totalPage - 1
              : currentPage;
          const data = {
            params: {
              page: page,
              apt_type: 2,
              apartment_code: this.search.apartment_code,
              from_size: this.search.fromsize,
              to_size: this.search.tosize,
              owner_resident: this.search.owner_resident,
              status: this.statusSelected
            }
          };
          this.GET_AVAILABLE_APARTMENT_LIST(data);
          this.SUCCESS_TOAST();
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
        }.bind(this)
      );
    },
    onPagination: function(data) {
      const filter = {
        params: {
          page: data.params.page,
          apt_type: 2,
          apartment_code: this.search.apartment_code,
          from_size: this.search.fromsize,
          to_size: this.search.tosize,
          owner_resident: this.search.owner_resident,
          status: this.statusSelected
        }
      };
      this.GET_AVAILABLE_APARTMENT_LIST(filter);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    closeModalMoveTo() {
      this.isModalMoveToServiceApartment = false;
    },
    selectedItems: function(list_apartment_id) {
      this.list_apartment_id = list_apartment_id;
    },
    onMoveToServiceApartment: function() {
      if (this.list_apartment_id.length <= 0) {
        this.ON_SHOW_TOAST({
          message: "Xin Vui Lòng Chọn 1 Căn Hộ",
          styleType: "danger"
        });
        return;
      }
      this.isModalMoveToServiceApartment = true;
    },
    onConfirmMoveToResidentApartment: function() {
      this.isLoading = true;
      let payload = {
        data: this.list_apartment_id,
        apartment_type: "resident_apt"
      };

      this.CHANGE_RESIDENT_TO_SERVICE_APARTMENT(payload)
        .then(
          function() {
            this.SUCCESS_TOAST();
            this.isLoading = false;
            this.isModalMoveToServiceApartment = false;
            const filter = {
              params: {
                page: 1,
                apt_type: 2,
                apartment_code: this.search.apartment_code,
                from_size: this.search.fromsize,
                to_size: this.search.tosize,
                owner_resident: this.search.owner_resident,
                status: this.statusSelected
              }
            };
            this.GET_AVAILABLE_APARTMENT_LIST(filter);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: this.messages[error.response.data.message],
              styleType: "danger"
            });
            this.isLoading = false;
          }.bind(this)
        );
    },
    getBookingStatus: function() {
      let apartment_booking_status = [];
      if (this.controlStatusBooking.isEmpty === true) {
        apartment_booking_status.push(BookingStatusEnum.WAITING);
      }
      if (this.controlStatusBooking.isConfirm === true) {
        apartment_booking_status.push(BookingStatusEnum.CONFIRMED);
      }
      if (this.controlStatusBooking.isDeposit === true) {
        apartment_booking_status.push(BookingStatusEnum.DEPOSIT);
      }
      if (this.controlStatusBooking.isOnboard === true) {
        apartment_booking_status.push(BookingStatusEnum.ONBOARD);
      }
      this.bookingDate.apartment_booking_status = apartment_booking_status;
    },
    onSearchAvailableApartment: function() {
      this.isLoading = true;
      this.getBookingStatus();

      const filter = {
        params: {
          page: 1,
          apt_type: 2,
          apartment_code: this.search.apartment_code,
          from_size: this.search.fromsize,
          to_size: this.search.tosize,
          owner_resident: this.search.owner_resident,
          status: this.statusSelected,
          checkin_datetime: utils.formatSqlDate(this.bookingDate.checkin_datetime, this.options.format, "DD/MM/YYYY"),
          checkout_datetime: utils.formatSqlDate(this.bookingDate.checkout_datetime, this.options.format, "DD/MM/YYYY"),
          absc: this.bookingDate.apartment_booking_status
          //absc: 0
        }
      };

      this.GET_AVAILABLE_APARTMENT_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.gridApartmentDataList = [];
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    makeColorButton: function(isStatus) {
      if (isStatus == "isEmpty") {
        this.controlStatusBooking.isEmpty = !this.controlStatusBooking.isEmpty;
      } else if (isStatus == "isConfirm") {
        this.controlStatusBooking.isConfirm = !this.controlStatusBooking
          .isConfirm;
      } else if (isStatus == "isOnboard") {
        this.controlStatusBooking.isOnboard = !this.controlStatusBooking
          .isOnboard;
      } else if (isStatus == "isCheckinSoon") {
        this.controlStatusBooking.isCheckinSoon = !this.controlStatusBooking
          .isCheckinSoon;
      } else if (isStatus == "isCheckoutSoon") {
        this.controlStatusBooking.isCheckoutSoon = !this.controlStatusBooking
          .isCheckoutSoon;
      } else {
        this.controlStatusBooking.isDeposit = !this.controlStatusBooking
          .isDeposit;
      }
    },
    getDataList: function(data_dict) {
      this.data_context_menu = data_dict;
      this.show_context_menu = false;
      this.is_both = true;
      this.obj_update.id = this.data_context_menu.id;
      this.obj_update.cleaning_status = this.data_context_menu.cleaning_status; // id of status
      //this.obj_update.cleaning_status_id = this.data_context_menu.cleaning_status_id;
      this.obj_update.cleaning_status_id =
        this.data_context_menu.cleaning_status_id != undefined &&
        this.data_context_menu.cleaning_status_id != 0
          ? this.data_context_menu.cleaning_status_id
          : 0; //id of cleaning service
    },
    notShowContextMenu: function() {
      if (this.is_both) {
        this.show_context_menu = false;
      } else {
        this.show_context_menu = true;
        this.data_context_menu = {};
      }
      this.is_both = false;
    },
    closeModalApartment: function(id_modal) {
      this.obj_update.id = 0;
      $("#" + id_modal).modal("hide");
    },
    openModalApartment: function(id_modal) {
      $("#" + id_modal).modal("show");
    },
    openCleaningService: function(id_modal, id, cleaning_status) {
      $("#" + id_modal).modal("show");
    },
    getCleaningStatus: function(apartment_id, cleaning_status) {
      this.cleaning_control[apartment_id] = cleaning_status;
    },
    getCleaningId: function(apartment_id, cleaning_id, status) {
      this.cleaning_control_update[apartment_id] = cleaning_id;
    },
    updateApartment: function() {
      this.$refs.LeaseBackApartmentInputView.onApartmentSubmit();
      $("#modal-update-apartment").modal("hide");
    },
    getAvailableApartment: function() {
      let checkout_datetime = new Date();
      checkout_datetime.setDate(checkout_datetime.getDate() + 7);
      this.bookingDate.checkin_datetime = this.$route.query.checkin_datetime != null
          ? this.$route.query.checkin_datetime
          : moment(new Date(), this.options.format).format("DD/MM/YYYY");
      this.bookingDate.checkout_datetime = this.$route.query.checkout_datetime != null
          ? this.$route.query.checkout_datetime
          : utils.formatSqlDate(checkout_datetime, this.options.format, "DD/MM/YYYY");

      if (
        this.bookingDate.checkin_datetime != null &&
        this.bookingDate.checkout_datetime != null
      ) {
        this.obj_update.checkin = this.bookingDate.checkin_datetime;
        this.obj_update.checkout = this.bookingDate.checkout_datetime;
        this.onSearchAvailableApartment();
      }
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_AVAILABLE_APARTMENT_LIST",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_PERMISSIONS_BYMODULE",
      "ON_SHOW_TOAST",
      "CHANGE_RESIDENT_TO_SERVICE_APARTMENT",
      // "GET_APARTMENT_CUSTOMER_INFORMATION_BOOKING_DETAIL",
      "DELETE_PROPERTY"
    ]),
    ...mapActions("bookingModule", [
      "ADD_BOOKING_PAYMENT",
      "SAVE_BOOKING_PAYMENT"
    ])
  },
  components: {
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    "date-picker": datePicker,
    "lte-booking": booking,
    "lte-modal-booking-detail": LTEModalBookingDetail,
    "leaseback-apartment-inputview": LeaseBackApartmentInputView,
    "leaseback-tenant-booking": LeaseBackTenantBooking,
    "leaseback-apartment-client-booking": LeaseBackApartmentClientBookingList,
    LeaseBackBookingPayment,
    "leaseback-apartment-cleaning-service": LeaseBackApartmentCleaningService
  },
  created() {
  },
  mounted() {
    this.options.format = sessionStorage.getItem('projectDateViewOptions');

    this.getAvailableApartment();
    // this.search.apartment_code = this.$store.state.apartmentSearchListStorage.apartmentCode;
    // this.search.fromsize = this.$store.state.apartmentSearchListStorage.fromSize;
    // this.search.tosize = this.$store.state.apartmentSearchListStorage.toSize;
    // this.search.owner_resident = this.$store.state.apartmentSearchListStorage.ownerResident;
    // this.statusSelected = !utils.isNull(
    //   this.$store.state.apartmentSearchListStorage.statusSelected
    // )
    //   ? this.$store.state.apartmentSearchListStorage.statusSelected
    //   : [];

    /*const data = {
      data: {
        page: 1,
        apt_type: 2,
        apartment_code: this.search.apartment_code,
        from_size: this.search.fromsize,
        to_size: this.search.tosize,
        owner_resident: this.search.owner_resident,
        status: this.statusSelected,
        checkin_datetime: this.bookingDate.checkin_datetime,
        checkout_datetime: this.bookingDate.checkout_datetime
      }
    };
    this.GET_AVAILABLE_APARTMENT_LIST(data);*/
    this.columnsApartment.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "apartmentlist"
      }
    };

    this.GET_PERMISSIONS_BYMODULE({
      params: {
        module_id: 4
      }
    });

    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    this.updateSelectedApartmentStatus();
  }
};
</script>

<style scoped>
.search {
  box-shadow: none;
  border-color: #d2d6de;
  z-index: 2;
  float: left;
  margin-bottom: 8px;
  margin-right: 5px;
  height: 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.size-180 {
  width: 180px;
}

.search-tools {
  padding-right: 0px;
  padding-left: 0px;
  width: auto;
}
.select-option-status {
  margin-top: -12px;
  display: inline-block;
}

.colorbutton {
  background-color: yellow;
  color: black;
}
@media only screen and (max-width: 1000px) {
  .select-option-status {
    float: none;
    margin-top: 4px;
  }
}
@media only screen and (max-width: 768px) {
  .select-option-status {
    float: none;
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackAvailableApartmentList.vue